import { api, LightningElement } from "lwc";
import { ContentSummaryConfig, ContentSummary } from "../contentSummary/types";

export default class extends LightningElement {
  @api summary: ContentSummary | null = null;
  @api titleMode: "anchor" | "button" | "text" = "anchor";

  private get borderTopStyles() {
    return `border-top-color: ${this.summary!.color};`;
  }

  private get config(): ContentSummaryConfig {
    return {
      titleMode: this.titleMode,
      variant: "tile",
    };
  }

  private onNavigate() {
    this.dispatchEvent(
      new CustomEvent("navigate", {
        detail: this.summary!,
      })
    );
  }
}
